import Effects from 'effects/Effects.js';
import AutoWahEffect from 'effects/AutoWah.js';
import PhaserEffect from 'effects/Phaser.js';
import StereoWidener from 'effects/StereoWidener.js';
import RingModulator from 'effects/RingModulator.js';
import Oscilloscope from 'effects/Oscilloscope.js';
import MultibandCompressor from 'effects/MultibandCompressor.js';
import UltraPhaser from 'effects/UltraPhaser.js';
import DelayEffect from 'effects/Delay.js';
import ConvolverReverbEffect from 'effects/ConvolverReverbEffect.js';
import Chebyshev from 'effects/Chebyshev.js';
import BitCrusherEffect from 'effects/BitCrusher.js';
import CompressorEffect from 'effects/Compressor.js';
import DistortionEffect from 'effects/Distortion.js';
import PitchShift from 'effects/PitchShift.js';
import Panner from 'effects/Panner.js';
import EQ3 from 'effects/EQ3.js';
import EQ10 from 'effects/EQ10.js';
import GateEffect from 'effects/Gate.js';
import EQ8 from 'effects/EQ8.js';
import ParameterContext from 'effects/ParameterContext.js';
import Saturator from 'effects/Saturator.js';
import TapeDelay from 'effects/TapeDelay.js';
import EffectRack from 'effects/rack/EffectRack.js';
import StereoDelay from 'effects/StereoDelay.js';
import GuitarAmpEffect from 'effects/GuitarAmpEffect.js';
import WaveFolder from 'effects/WaveFolder.js';
import VocoderEffect from 'effects/VocoderEffect.js';
import Follower from 'effects/Follower.js';
import FrequencyShifter from 'effects/FrequencyShifter.js';
import TransientShaper from 'effects/TransientShaper.js';

export const nameToEffect =  {
        "Filter" : (sequencerEngine) => new Effects.FilterEffect(sequencerEngine), 
        "Wave Folder" : (sequencerEngine) => new WaveFolder(sequencerEngine), 
        "Delay" : (sequencerEngine) => new DelayEffect(sequencerEngine),
        "Reverb":  (sequencerEngine) => new Effects.ReverbEffect(sequencerEngine),
        "Convolver Reverb":  (sequencerEngine) => new ConvolverReverbEffect(sequencerEngine),
        "Chorus":  (sequencerEngine) => new Effects.ChorusEffect(sequencerEngine),
        "Multiband Compressor":  (sequencerEngine) => new MultibandCompressor(sequencerEngine),
        "Distortion":  (sequencerEngine) => new DistortionEffect(sequencerEngine),
        "Compressor":  (sequencerEngine) => new CompressorEffect(sequencerEngine),
        "Bit Crusher":  (sequencerEngine) => new BitCrusherEffect(sequencerEngine),
        "Ultra Phaser":  (sequencerEngine) => new UltraPhaser(sequencerEngine),
        "Pitch Shift":  (sequencerEngine) => new PitchShift(sequencerEngine),
        "Panner":(sequencerEngine) => new Panner(sequencerEngine),
        "EQ8":(sequencerEngine) => new EQ8(sequencerEngine),
        "Chebyshev":(sequencerEngine) => new Chebyshev(sequencerEngine),
        "Stereo Widener":(sequencerEngine) => new StereoWidener(sequencerEngine),
        "Tape Delay":(sequencerEngine) => new TapeDelay(sequencerEngine),
        "Saturator":(sequencerEngine) => new Saturator(sequencerEngine),
        "Stereo Delay":(sequencerEngine) => new StereoDelay(sequencerEngine),
        "Oscilloscope":(sequencerEngine) => new Oscilloscope(sequencerEngine),
        "Effect Rack":(sequencerEngine) => new EffectRack(sequencerEngine),
        "Guitar Amp":(sequencerEngine) => new GuitarAmpEffect(sequencerEngine),
        "Ring Modulator":(sequencerEngine) => new RingModulator(sequencerEngine),
        "Vocoder": (sequencerEngine) => new VocoderEffect(sequencerEngine),
        "Follower": (sequencerEngine) => new Follower(sequencerEngine),
        "Frequency Shifter": (sequencerEngine) => new FrequencyShifter(sequencerEngine),
        "Transient Shaper": (sequencerEngine) => new TransientShaper(sequencerEngine),
};

// initializes an effect from saved json parameters
export function getEffect(effectJson, tracks, sequencerEngine, trackNumber) {
    var name = effectJson.name;
    var effect = nameToEffect[name](sequencerEngine);

    if (trackNumber !== undefined) {
        let context = new ParameterContext()
            .forTrack(tracks[trackNumber]);
        effect.registerContext(context);
    }

    console.log('about to fromJson');
    let bulk = effect.fromJson(effectJson, tracks, trackNumber);
    return {effect, bulk};
}

